import contains from './contains';
import values from './values';
export default (function (obj, value) {
  return contains(values(obj), value);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/has-value.js
// module id = 79
// module chunks = 0